import { cn } from "@workspace/ui";

import type { ComponentProps } from "react";

export const Section = (props: ComponentProps<"section">) => {
  return (
    <section
      {...props}
      className={cn(
        "mx-auto flex flex-col items-center gap-8 px-6 py-12 sm:container md:py-14 lg:py-14",
        props.className,
      )}
    />
  );
};

export const SectionHeader = (props: ComponentProps<"div">) => {
  return (
    <header
      {...props}
      className={cn(
        "mx-auto flex max-w-5xl flex-col items-center gap-3 text-center",
        props.className,
      )}
    />
  );
};

export const SectionBadge = (props: ComponentProps<"div">) => {
  return (
    <div
      {...props}
      className={cn(
        "text-foreground inline-flex h-8 items-center rounded-full border px-3 py-0.5 text-xs font-medium shadow-xs sm:text-sm",
        props.className,
      )}
    />
  );
};

export const SectionTitle = ({
  as,
  ...props
}: ComponentProps<"h2"> & {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}) => {
  const As = as ?? "h2";

  return (
    <As
      {...props}
      className={cn(
        "text-foreground max-w-4xl text-3xl leading-tight font-semibold tracking-tighter text-balance sm:text-4xl md:text-5xl",
        props.className,
      )}
    />
  );
};

export const SectionDescription = (props: ComponentProps<"p">) => {
  return (
    <p
      {...props}
      className={cn(
        "text-muted-foreground mt-1 max-w-6xl text-balance text-base sm:text-lg md:text-xl",
        props.className,
      )}
    />
  );
};
